export default __webpack_public_path__ + "static/media/contact.2cc9015d.gif";